// NPM
import React from 'react';

export default function RoundedRect(props) {
  const { x, y, width, height, radius, tlRounded, trRounded, blRounded, brRounded, ...otherProps } = props;

  var pathD;
  pathD  = "M" + (x + radius) + "," + y;
  pathD += "h" + (width - (radius * 2));

  if(trRounded) { 
    pathD += "a" + radius + "," + radius + " 0 0 1 " + radius + "," + radius; 
  }
  else { 
    pathD += "h" + radius; 
    pathD += "v" + radius; 
  }

  pathD += "v" + (height - 2 * radius);

  if(brRounded) { 
    pathD += "a" + radius + "," + radius + " 0 0 1 " + -radius + "," + radius; 
  }
  else { 
    pathD += "v" + radius; 
    pathD += "h" + -radius; 
  }

  pathD += "h" + ((2 * radius) - width);

  if(blRounded) { 
    pathD += "a" + radius + "," + radius + " 0 0 1 " + -radius + "," + -radius; 
  }
  else { 
    pathD += "h" + -radius; 
    pathD += "v" + -radius; 
  }

  pathD += "v" + (2 * radius - height);

  if(tlRounded) { 
    pathD += "a" + radius + "," + radius + " 0 0 1 " + radius + "," + -radius; 
  }
  else { 
    pathD += "v" + -radius; 
    pathD += "h" + radius; 
  }

  pathD += "z";

  return <path d={ pathD } { ...otherProps } />
}